import ScalarButton_default from "./ScalarButton.vue.js";
export { ScalarButton_default as ScalarButton };
